export default {
  methods: {
    formatPrice(value) {
      const decimals = value.toString().includes('.') ? 2 : 0
      if (typeof value !== 'number') {
        value = parseFloat(value)
      }

      return value.toFixed(decimals)
    }
  }
}
